import React, { useState, useCallback, useMemo } from 'react';

import { Input } from 'antd';
import Axios from 'axios';

import styled from 'styled-components';

import FlexContainer from '@components/Gui/FlexContainer';
import AddCallSheetContactCard from '@components/Project/ProjectContacts/AddCallSheetContactCard';

const SearchViewWrapper = styled.div`
    padding: 2rem 0;

    .search-box-field {
        width: 30rem;
    }
    .contacts-list {
        padding-top: 0.5rem;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
    }
`;

// Funzione debounce helper - fuori dal componente
const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(null, args), delay);
    };
};

const AddCallSheetSearchView = ({ onChangeView, onSelectConnection }) => {
    const [contacts, setContacts] = useState([]);
    const [cache, setCache] = useState('');
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('');

    // Debounce per le ricerche API
    const debouncedSearch = useCallback(
        debounce((searchTerm) => {
            getContacts(searchTerm);
        }, 300), // 300ms di delay
        []
    );

    const groupedContacts = useMemo(() => {
        const contactsWithContactNameAndIdProperty = contacts.map((contact) => ({
            ...contact,
            ContactNameAndId: `${contact.ContactName}-${contact.ContactID}`,
        }));

        const grouped = contactsWithContactNameAndIdProperty.reduce((acc, contact) => {
            const key = contact.ContactNameAndId;

            if (!acc[key]) {
                // Crea un nuovo gruppo con le proprietà del primo contatto
                acc[key] = {
                    Name: contact.ContactName,
                    ContactID: contact.ContactID,
                    ContactNameAndId: key,
                    Connections: [],
                };
            }

            // Aggiungi il contatto all'array Connections
            acc[key].Connections.push({
                ID: contact.ID,
                Name: contact.Name,
                Surname: contact.Surname,
                Role: contact.Role,
                TypeName: contact.TypeName,
            });

            return acc;
        }, {});

        return Object.values(grouped); // Converte l'oggetto in array
    }, [contacts]);

    // Predicato di ricerca separato e riutilizzabile
    const matchesSearchTerm = (contact, searchTerm) => {
        const normalizedSearch = searchTerm.toLowerCase();

        const searchableFields = [
            contact.ContactName,
            contact.Name,
            contact.Role,
            contact.Surname,
            contact.Name && contact.Surname ? `${contact.Name} ${contact.Surname}` : null,
        ].filter(Boolean);

        return searchableFields.some((field) => field.toLowerCase().includes(normalizedSearch));
    };

    // Funzione per filtrare i contatti esistenti
    const filterExistingContacts = (searchTerm) => {
        return contacts.filter((contact) => matchesSearchTerm(contact, searchTerm));
    };

    // Funzione per determinare se usare la cache
    const shouldUseCache = (inputValue) => {
        return cache && cache.length >= 3 && inputValue.includes(cache) && contacts.length > 0;
    };

    const handleClickConnection = async (simpleConnection) => {
        setCache('');
        try {
            const connection = await Axios.get(`/connections/${simpleConnection.ID}`);
            onSelectConnection(connection);
            onChangeView('form');
        } catch (error) {
            console.error('Get Connection Error => ', error);
        }
    };

    const getContacts = async (searchTerm) => {
        setLoading(true);
        try {
            const contacts = await Axios.get(`/contacts/SearchConnections/${searchTerm}`);
            setContacts(contacts);
            setLoading(false);
        } catch (error) {
            console.error('Search Contact Error => ', error);
            setLoading(false);
        }
    };

    const handleSearch = (event) => {
        const inputValue = event.target.value;
        setFilter(inputValue);

        // Reset se input troppo corto
        if (inputValue.length < 3) {
            setContacts([]);
            setCache(inputValue);
            return;
        }

        // Usa cache se possibile
        if (shouldUseCache(inputValue)) {
            const filteredContacts = filterExistingContacts(inputValue);
            setContacts(filteredContacts);
            setCache(inputValue);
        } else {
            // Usa debounce per le ricerche API
            setCache(inputValue);
            debouncedSearch(inputValue);
        }
    };

    return (
        <SearchViewWrapper>
            <p>
                Type a <strong>contact name</strong> or a <strong>role</strong>
            </p>
            <FlexContainer mg={'0 0 16px'}>
                <Input
                    className="search-box-field"
                    size="large"
                    id="search-input"
                    value={filter}
                    autoComplete="off"
                    placeholder="contact name / role"
                    onChange={handleSearch}
                />
            </FlexContainer>
            <div className="contacts-list">
                {groupedContacts.map((contact) => (
                    <AddCallSheetContactCard
                        key={contact.ContactID}
                        contact={contact}
                        onClick={handleClickConnection}
                    />
                ))}

                {/* <NwDivider textSize="big" bold dark>
                    Select an existing contact
                </NwDivider> */}
                {/* <List
                    loading={loading}
                    itemLayout="horizontal"
                    dataSource={contacts}
                    renderItem={(connection, index) => {
                        return (
                            <List.Item
                                className="ant-list-item-top"
                                key={index}
                                onClick={() => onConnectionClick(connection)}
                            >
                                <div className="contact-list-item">
                                    <div className="contact-list-icon">
                                        <NwIcon
                                            icon={
                                                connection.TypeName === 'Place'
                                                    ? byPrefixAndName.fasl['home-alt']
                                                    : byPrefixAndName.fasl['user']
                                            }
                                        />
                                    </div>
                                    {connection.TypeName === 'People' ? (
                                        <div className="contact-list-details">
                                            <div className="contact-connection-name">
                                                {getRoleText(connection).toUpperCase()}
                                                {getValidText(connection.ContactName).toUpperCase()}
                                            </div>
                                            <div className="contact-name">{`${getValidText(connection.Name)} ${getValidText(connection.Surname)}`}</div>
                                        </div>
                                    ) : (
                                        <div className="contact-list-details">
                                            <div className="contact-connection-name">
                                                {getValidText(connection.ContactName).toUpperCase()}
                                            </div>
                                            <div className="contact-name">{getValidText(connection.Name)}</div>
                                        </div>
                                    )}
                                </div>
                            </List.Item>
                        );
                    }}
                /> */}
                {/* {!showAllContacts && contacts.length > 4 && (
                    <FlexContainer justifyContent="center">
                        <NwLinkButton onClick={() => setShowAllContacts(true)} label="Load More" />
                    </FlexContainer>
                )} */}
            </div>
        </SearchViewWrapper>
    );
};

export default AddCallSheetSearchView;
